import Logo from '@/assets/images/adaptee-gastro-logo.svg'
import { ColorEnum } from '@/constants/color'
import { useScreenOrientation } from '@/hooks/screen'
import { Header } from '@react-navigation/elements'
import { FC } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const logoMarginTop = 27
const logoHeight = 45

const AuthHeader: FC = () => {
    const orientation = useScreenOrientation()

    const insets = useSafeAreaInsets()

    const inset = orientation === 'portrait' ? insets.top : 0
    const logoVerticalSpace = logoMarginTop + logoHeight

    return (
        <Header
            title=""
            headerTitle={() => <Logo />}
            headerTitleAlign="center"
            headerTitleContainerStyle={{ marginTop: 'auto' }}
            headerShadowVisible={false}
            headerStyle={{
                backgroundColor: ColorEnum.JET_800,
                height: inset + logoVerticalSpace,
            }}
        />
    )
}

export default AuthHeader
